/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_required_fields = /** @type {(inputs: {}) => string} */ () => {
	return `* Povinná pole`
};

const da_required_fields = /** @type {(inputs: {}) => string} */ () => {
	return `* Obligatoriske felter`
};

const de_required_fields = /** @type {(inputs: {}) => string} */ () => {
	return `* Pflichtfelder`
};

const en_required_fields = /** @type {(inputs: {}) => string} */ () => {
	return `* Required fields`
};

const es_required_fields = /** @type {(inputs: {}) => string} */ () => {
	return `* Campos obligatorios`
};

const fr_required_fields = /** @type {(inputs: {}) => string} */ () => {
	return `* Champs obligatoires`
};

const hu_required_fields = /** @type {(inputs: {}) => string} */ () => {
	return `* Kötelező mezők`
};

const it_required_fields = /** @type {(inputs: {}) => string} */ () => {
	return `* Campi obbligatori`
};

const nl_required_fields = /** @type {(inputs: {}) => string} */ () => {
	return `* Verplichte velden`
};

const pl_required_fields = /** @type {(inputs: {}) => string} */ () => {
	return `* Pola wymagane`
};

const pt_required_fields = /** @type {(inputs: {}) => string} */ () => {
	return `* Campos obrigatórios`
};

const sv_required_fields = /** @type {(inputs: {}) => string} */ () => {
	return `* Obligatoriska fält`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const required_fields = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.required_fields(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("required_fields", locale)
	if (locale === "cs") return cs_required_fields(inputs)
	if (locale === "da") return da_required_fields(inputs)
	if (locale === "de") return de_required_fields(inputs)
	if (locale === "en") return en_required_fields(inputs)
	if (locale === "es") return es_required_fields(inputs)
	if (locale === "fr") return fr_required_fields(inputs)
	if (locale === "hu") return hu_required_fields(inputs)
	if (locale === "it") return it_required_fields(inputs)
	if (locale === "nl") return nl_required_fields(inputs)
	if (locale === "pl") return pl_required_fields(inputs)
	if (locale === "pt") return pt_required_fields(inputs)
	return sv_required_fields(inputs)
};